import { AppContext } from '../schema/AppContext';
import type { ListenerType } from '../schema/ListenerType';

/**
 * Method to create a new app context for a workflow.
 */
export function createAppContext(
    cId?: string,
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    defaultPayload?: any,
    listeners?: ListenerType[]
): AppContext {
    return new AppContext(cId, defaultPayload, listeners);
}
